import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Button, Input } from "reactstrap";
import * as Yup from "yup";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { getTicketDetails, sendTicketAnswer } from "src/store/ticket/saga";
import { TicketDetailDto } from "src/store/ticket/type";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import TicketMessageContainer from "./componentes/ticketMessage";
import FileUploader from "src/components/file-upload";
import GetInput from "src/components/Form/GetInput";

const TicketDetails = ({
  selectedTicket,
  setSelectedTicket,
}: {
  setSelectedTicket: (selectedTicket: TicketDetailDto) => void;
  selectedTicket: TicketDetailDto;
}) => {
  const { t } = useTranslation();
  const [messageBox, setMessageBox] = useState<any>(null);
  const dispatch = useDispatch();
  const scrollToBottom = useCallback(() => {
    if (messageBox) {
      messageBox.scrollTop = messageBox.scrollHeight + 1000;
    }
  }, [messageBox]);
  useEffect(() => {
    if (!isEmpty(selectedTicket)) scrollToBottom();
  }, [selectedTicket, scrollToBottom]);

  return (
    <React.Fragment>
      <div className="ticketDetailsPage mb-3 ">
        <PerfectScrollbar
          className="chat-conversation px-2"
          style={{ height: "100%" }}
          containerRef={(ref) => setMessageBox(ref)}
        >
          <div>
            {selectedTicket.TicketAnswers.map((x) => (
              <TicketMessageContainer
                key={x.Id}
                ticket={selectedTicket}
                message={x}
              />
            ))}
          </div>
        </PerfectScrollbar>
        {selectedTicket && (
          <>
            {!(
              selectedTicket.TicketStatusTypeId === 3 ||
              selectedTicket.TicketStatusTypeId === 4
            ) ? (
              <Formik
                initialValues={{
                  Message: "",
                  Document: "",
                }}
                validationSchema={Yup.object().shape({
                  Message: Yup.string().required(),
                })}
                onSubmit={(values, { resetForm }) => {
                  dispatch(
                    sendTicketAnswer({
                      payload: {
                        onSuccess: () => {
                          resetForm();
                          dispatch(
                            getTicketDetails({
                              payload: {
                                onSuccess: (message, payload) =>
                                  setSelectedTicket(payload),
                                onError: () => {},
                              },
                              id: selectedTicket.Id,
                            })
                          );
                        },
                        onError: () => {},
                      },
                      id: selectedTicket?.Id,
                      body: values,
                    })
                  );
                }}
              >
                {({
                  errors,
                  values,
                  handleChange,
                  setFieldValue,
                  handleSubmit,
                }) => (
                  <>
                    <div className=" w-100">
                      <Input
                        type="textarea"
                        style={{ height: "65px" }}
                        error={errors.Message}
                        value={values.Message}
                        onChange={(e) => {
                          return setFieldValue(`Message`, e.target.value);
                        }}
                      />

                      <div className="d-flex justify-content-end mt-1">
                        <div className="d-flex ">
                          <div className="mx-2 d-flex align-items-center gap-2 justify-content-center">
                            {values.Document !== "" && (
                              <div className="font-size-12 badge bg-light">
                                <span
                                  className="fw-bold me-2"
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setFieldValue("Document", "")}
                                >
                                  X
                                </span>
                                {
                                  //@ts-ignore
                                  values.Document.name
                                }
                              </div>
                            )}
                            <FileUploader
                              className=" btn-light"
                              onChange={(event) => {
                                let files = event.target.files;
                                setFieldValue("Document", files[0]);
                              }}
                              title={t("Tickets.Documents").toString()}
                            />
                          </div>
                          <Button
                            type="button"
                            color="primary"
                            onClick={() => handleSubmit()}
                            className="btn btn-success bg-pr border-pr chat-send w-md"
                          >
                            <span className="d-none d-sm-inline-block me-2">
                              {t("Tickets.Reply")}
                            </span>
                            <i className="mdi mdi-send float-end" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Formik>
            ) : (
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  borderRadius: 6,
                  backgroundColor: "#80808040",
                  paddingBlock: 40,
                }}
              >
                {t("CLOSED")}
              </div>
            )}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default TicketDetails;
